import { Flex } from '@chakra-ui/react';
import { useState } from 'react';
import { TexasAgent } from '../agent/TexasAgent';
import { ContextNavigation } from './context/ContextNavigation';
import { GlobalNavigation } from './global/GlobalNavigation';
import { useNavigationStore } from './hooks/useNavigationStore';

export function Navigation() {
  const { activeState, context } = useNavigationStore();
  const [isRioOpen, setIsRioOpen] = useState(false);

  return (
    <Flex flexShrink={0} h="100dvh">
      <GlobalNavigation
        activeState={activeState}
        isRioOpen={isRioOpen}
        onRioToggle={() => setIsRioOpen((isOpen) => !isOpen)}
      />
      {isRioOpen && <TexasAgent onClose={() => setIsRioOpen(false)} />}
      {context && (
        <ContextNavigation activeState={activeState} context={context} />
      )}
    </Flex>
  );
}
